import styled, { css } from "styled-components/macro";

import { colors, space, fontSize, fontStyle } from "shared/styles/constants";

export interface StyledPlaceholderProps {
  noBorder?: boolean;
  isRounded?: boolean;
  backgroundImage?: string;
}

export const StyledPlaceholder = styled.div<StyledPlaceholderProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  border: 2px dashed ${colors.grey1};
  padding: ${space.s};

  ${fontStyle.bold}
  ${fontSize.xs}
  color: ${colors.grey4};
  text-align: center;

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-image: url(${backgroundImage});
      background-position: center;
      background-size: cover;
    `}

  ${({ isRounded }) =>
    isRounded &&
    css`
      border-radius: 50%;
    `}

    ${({ noBorder }) =>
    noBorder &&
    css`
      border: none;
    `}
`;
